import { createFileRoute } from "@tanstack/react-router";
import { DealIndexRedirect } from "../../../../../pages/deal-redirect-page/deal-redirect-page";

export const Route = createFileRoute("/_auth/_deal/deals/$dealId/")({
  component: DealIndexRedirect,
});
